export const newsLetterModalProps = {
  isShowOptionBtn: true,
  isShowContactForm: true,
  hideBody: true,
  isSquare: true
}
